import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { SettingsRoutes } from '@/router/routes';

/**
 * Alert banner displayed when QuickBooks integration is not connected.
 * Shows a warning message and a button to navigate to integrations settings.
 *
 * Used in BillsPage and InvoicesPage to inform users they need to connect
 * QuickBooks before they can use finance features.
 */
export function QuickBooksNotConnectedMessage() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Alert variant="warning" className="mb-4">
      <Settings className="h-5 w-5" />
      <div className="flex w-full flex-row content-between items-start justify-between">
        <div>
          <AlertTitle>{t('quickbooks.notConnected.title')}</AlertTitle>
          <AlertDescription>{t('quickbooks.notConnected.description')}</AlertDescription>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(SettingsRoutes.Integrations)}
          className="ml-4 shrink-0"
        >
          {t('quickbooks.notConnected.action')}
        </Button>
      </div>
    </Alert>
  );
}
